import React, { Component } from 'react';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText, SubmitBtn, MidCifBtn} from '../../theme/MorsTheme';
import {Row,Col,Form, Modal} from 'react-bootstrap';

export default class morsContactUs extends Component {

render() {

    return (
		<div>
			<BodyHeaderDiv>
                <BodyHeaderText>Contact Us</BodyHeaderText>
            </BodyHeaderDiv>

            <ContentDiv>
			<Row  md={9} lg={12} sm={12} xs={12} >
			
				<Col className="col-xl-4 col-md-4 col-5">
					Metro Manila<br />
					PLDT<br />
					Globe<br /><br />
					Domestic Toll-Free<br />
					PLDT
					<br />
					Globe
					<br />
					Fax
					<br />
					Email add
					<br />	
				</Col>
				<Col className="col-xl-1 col-md-1 col-1">
					<br />
					:<br />
					:<br />
					<br /><br />
					:<br />
					:<br />
					:<br />
					:	
				</Col>
				<Col className="col-xl-4 col-md-4 col-5">
					<br/>
					8702-6900<br/>
					7909-6900<br/><br/><br/>
					1-800-10-7026900<br/>
					1-800-8-909-6900<br/>
					632 8727-2104<br/>
					merchantsvcs@bdo.com.ph<br />	
				</Col>
			</Row>
			
			
			</ContentDiv>
		</div>
		);

	}

}